module.exports = __webpack_public_path__ + "static/media/tab-1-pic.fab25bc3.png";